module.exports = __webpack_public_path__ + "static/media/default-avatar.c3e8faf4.png";